/* Selector file rule: root-level functions in this file must be exported selectors only. Move helper functions to lib files. */
import { createSelector } from 'reselect';
import buildSidebarSearchResults from '@/lib/sidebarSearch/buildSidebarSearchResults.js';
import { automationScheduleItems, automationTriggerItems } from '@/redux/selectors/pieveSelectors/automationSharedSelectors.js';
import { automationWorkflows } from '@/redux/selectors/pieveSelectors/automationWorkflowSelectors.js';

const EMPTY_ARRAY = Object.freeze([]);

/* The chats the server matched for the sidebar search box; a separate slot so the sidebar's
   own paginated thread list never mixes with search hits. */
export const sidebarSearchThreads = (state) => state?.pieve?.sidebarSearchThreads || EMPTY_ARRAY;

export const sidebarSearchResults = createSelector([sidebarSearchThreads, automationScheduleItems, automationTriggerItems, automationWorkflows, (_, query) => query], (threads, schedules, triggers, workflows, pages, query) => {
  return buildSidebarSearchResults({ query, threads, schedules, triggers, workflows });
});
